// eslint-disable-next-line no-unused-vars
import * as React from "react";
import styled from "@emotion/styled";
import { Typography, Tabs as MuiTabs } from "@mui/material";

export const Tabs = styled(MuiTabs)`
    .MuiTabs-scroller {
        max-width: calc(100vw - 912px);
    }
`;

export const TabLabel = styled(Typography)`
    overflow: hidden;
    text-overflow: ellipsis; 
    white-space: nowrap;
    max-width: 150px;
`;